import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

// Components
import ButtonPill from '../../../../components/react-button-pill/index';

const FilterFooter = ({totalTickets, onClick}) => {
  const {totalListings: totListings, totalTickets: totTickets} = totalTickets || {};
  const disableViewtotalTicketsBtn = totListings === 0;

  return (
    <div className="FilterFooter">
      <div className="FilterFooter__listingsCount">
        <ButtonPill className="FilterFooter__listingsCountBtn" disabled={disableViewtotalTicketsBtn} onClick={onClick}>
          {totListings > 0 ? (
            <FormattedMessage
              id="FilterFooter.IfTotalTicketsLabel"
              defaultMessage="View {totTickets, plural, one {# ticket} other {# tickets}}"
              values={{totTickets}}
            />
          ) : (
            <FormattedMessage id="FilterFooter.IfNoTotalTicketsLabel" defaultMessage="View 0 ticket" />
          )}
        </ButtonPill>
      </div>
    </div>
  );
};

FilterFooter.propTypes = {
  totalTickets: PropTypes.object,
  onClick: PropTypes.func.isRequired,
};

export default FilterFooter;
